import { render, staticRenderFns } from "./appAssetContent.vue?vue&type=template&id=73c20c81&scoped=true"
import script from "./appAssetContent.vue?vue&type=script&lang=js"
export * from "./appAssetContent.vue?vue&type=script&lang=js"
import style0 from "./appAssetContent.vue?vue&type=style&index=0&id=73c20c81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c20c81",
  null
  
)

export default component.exports